import React from "react";
import PropTypes from "prop-types"
import {Table} from 'antd';
import {defaultPagination} from "../../util/Util"


const ImportTableDetail = ({dataSource, loading}) => {
    console.log("datasource", dataSource);
    const columns = [
        {title: 'Country', dataIndex: 'country'},
        {title: 'Created last 7 days', dataIndex: 'createdWeek'},
        {title: 'Updated last 7 days', dataIndex: 'updatedWeek'},
        {title: 'Validated last 7 days', dataIndex: 'validatedWeek'},
        {title: 'Created last 30 days', dataIndex: 'createdMonth'},
        {title: 'Updated last 30 days', dataIndex: 'updatedMonth'},
        {title: 'Validated last 30 days', dataIndex: 'validatedMonth'},
        {title: 'Created YTD', dataIndex: 'createdYear'},
        {title: 'Updated YTD', dataIndex: 'updatedYear'},
        {title: 'Validated YTD', dataIndex: 'validatedYear'},
        {title: 'Overall', dataIndex: 'overall'},

    ];



    return (
        <Table
            dataSource={dataSource}
            loading={loading}
            columns={columns}
            size="small"
            bordered
            rowKey={record => record.id}
            pagination={defaultPagination()}
        />
    );
};
ImportTableDetail.propTypes = {
    dataSource: PropTypes.array.isRequired,
    onSelectChange: PropTypes.func,
    loading: PropTypes.bool.isRequired,
    compact: PropTypes.bool.isRequired
};

export default ImportTableDetail



// WEBPACK FOOTER //
// ./src/js/browse/import/ImportDetailTable.js